import script from "./ShareBetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareBetModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareBetModal.vue?vue&type=style&index=0&id=57fb8f38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57fb8f38"]])

export default __exports__